import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CANCEL_ORDER, STR_CANCELLATION_REASON, STR_CATEGORY, STR_COULD_NOT_FETCH_DATA, STR_CROPS, STR_DELIVERY_LOCATION, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_REASON, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_OPTIONAL, STR_ORDER_NOTES, STR_ORDER_QUANTITY, STR_OVERALL_COST, STR_PACKAGING_COST, STR_PLACE_ORDER, STR_PLACE_YOUR_ORDER, STR_POST_ITEM, STR_SHIPPING_COST, STR_SUBMIT, STR_SUCCESS, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEES, STR_UNIT, STR_UNIT_PRICE } from "../Strings";
import NapaAddressPicker from "../ones/NapaAddressPicker";
import ImageSlider from "../ones/ImagesSlider";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import OrderInfo from "../ones/OrderInfo";
import OrderReceipt from "../ones/OrderReceipt";


export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	const [ready, setReady] = useState(false);


	const [data, setData] = useState(null);
	const [paymentsProfile, setPaymentsProfile] = useState(null);
	
	const [cancellationReason, setCancellationReason] = useState("");
	

	async function init() {
		setReady(false);
		await Promise.all([
			getData(),
			getPaymentsProfile(),
		])
		setReady(true)
	}

	

	async function getData() {
		await callApi("get-order-data", { orderUuid: uuid }).then((response) => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	}

	async function getPaymentsProfile() {
		await callApi("get-order-payments-profile", { orderUuid: uuid }).then((response) => {
			if(response.status === 1) {
				setPaymentsProfile(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	}

	

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	if (ready && data && paymentsProfile) {
		return (
			<div className="container">
				<div className="row">
					
					<div className="col-md-12">
						<OrderInfo paymentsProfile={paymentsProfile} data={data} />
					</div>

					

					

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}
	
}